<template>
  <div id="app">
    <component :is="currentComponent" @navigate="handleNavigate" :query="queryParam" />
  </div>
</template>

<script>
import IndexView from './components/IndexView.vue';
import LoaderView from './components/LoaderView.vue';

export default {
  name: "SP",
  components: {
    IndexView,
    LoaderView
  },
  data() {
    return {
      currentComponent: 'LoaderView',
      queryParam: ''
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.queryParam = params.get("e") || "";
  },
  methods: {
    handleNavigate(event) {
      this.currentComponent = event.component;
      this.queryParam = event.query || this.queryParam;
    }
  }
};
</script>
